// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__cawgp","savedScreensWrapper":"style_savedScreensWrapper__XatTu","selectedScreen":"style_selectedScreen__EZvh2"};